export type GalleryItem = {
  title: string
  description: string
  image: string
  alt: string
  span: 'tall' | 'square' | 'wide'
}

export const galleryItems: GalleryItem[] = [
  {
    title: 'Barras grandes de autor',
    description:
      'Jabones de tamaño boutique con marmoleado natural y aceites nutritivos.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b42e9d91-4ac9-4755-a8a6-57de2daabc22.jpg',
    alt: 'Barras grandes de jabón artesanal con marmoleado verde y crema apiladas junto a eucalipto',
    span: 'tall',
  },
  {
    title: 'Jaboncillos chiquitos',
    description:
      'Mini jabones ideales para regalos, souvenirs y kits de degustación.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8d1eb5bb-092b-43b0-bd34-d891d8a9f970.jpg',
    alt: 'Bandeja de madera con muchos jaboncillos pequeños en tonos pastel con pétalos secos',
    span: 'square',
  },
  {
    title: 'Formas y moldes',
    description:
      'Flores, corazones, hexágonos y caracolas para líneas temáticas.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8d62e045-6471-4d67-a6a6-33cc9589b7c5.jpg',
    alt: 'Jabones de glicerina con formas de flores, corazones y caracolas sobre un plato de cerámica',
    span: 'square',
  },
  {
    title: 'Capas y marmoleado',
    description:
      'Técnicas de vertido en capas y swirl para terminaciones profesionales.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c616fe33-736f-4d97-8c65-ca15f5712c69.jpg',
    alt: 'Primer plano de jabones en capas de arcilla, avena y carbón con veteado marmolado',
    span: 'wide',
  },
  {
    title: 'Translúcidos con botánicos',
    description:
      'Glicerina transparente con flores y hierbas suspendidas adentro.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e4036d8-33d6-4867-a985-2f691076c70a.jpg',
    alt: 'Jabones de glicerina translúcidos a contraluz con flores secas suspendidas en su interior',
    span: 'wide',
  },
]
